import styled from "styled-components";

export const NotificationTitleContainer = styled.span`
  font: 400 0.875rem/1.3125rem "Inter";
  color: ${({ theme }) => theme.notification.title};

  margin: 0;

  @media (max-width: 1366px) {
    font: 400 0.75rem/1.125rem "Inter";
  }
`;
